var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrossSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187432",
    "data-name": "Group 187432",
    transform: "translate(7573 3347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78714",
    "data-name": "Path 78714",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm2.011,7.048H13.97a.872.872,0,0,1,.8.458.888.888,0,0,1-.758,1.309c-.609-.014-1.358,0-1.992-.006a3.64,3.64,0,0,1-3.459,2.76c.855.856,1.722,1.726,2.578,2.578a.888.888,0,1,1-1.211,1.3q-.6-.588-1.185-1.182c-1.057-1.057-1.875-1.875-2.891-2.889a1.039,1.039,0,0,1-.286-.469.878.878,0,0,1,.761-1.088c.52-.021,1.1,0,1.632,0a2.084,2.084,0,0,0,2.176-1H8.194l-1.758,0a.845.845,0,0,1-.781-.445A.885.885,0,0,1,6.443,7.05l1.168,0h2.516a1.855,1.855,0,0,0-.909-.832A4.165,4.165,0,0,0,7.59,6.064H6.432a.884.884,0,0,1-.38-1.685.97.97,0,0,1,.37-.084q2.08,0,4.162,0l3.417,0a.879.879,0,0,1,.872.762.892.892,0,0,1-.882,1.005c-.75,0-1.623,0-2.38,0a7.387,7.387,0,0,1,.4.983Z",
    transform: "translate(-7573 -3347)",
    fill: "#7D96FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrossSales);
export default __webpack_public_path__ + "static/media/gross-sales.45962e4b6f62df74ecf2594f4eaf4403.svg";
export { ForwardRef as ReactComponent };